import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Table, Image } from "antd";
import { showColumnAction } from "pages/CategoryPage/CategoryListTableWidget/CategoryListTableColumn";
import { getCurrencyInfo } from "utils/GlobalFunctions";

const DetailTable = (props) => {
  const [isBusy, setIsBusy] = useState(false);
  const { dataList, onUpdateAction, onDeleteAction } = props;
  if (dataList === undefined) return <div />;
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
      },
    },
    {
      title: "Avatar",
      dataIndex: "thumbnail_image",
      render: (text, record) => {
        if (record.avatar_image === null) {
          return (
            <img
              className="recipe-thumbnail-img"
              src={"/assets/icons/ic_picture.svg"}
            />
          );
        } else {
          return (
            <Image
              className="recipe-thumbnail-img"
              src={record.thumbnail_image}
            />
            // <img className="recipe-thumbnail-img" src={record.thumbnail_image} />
          );
        }
      },
    },
    {
      title: "Month Salary",
      dataIndex: "month_salary",
      align: "center",
      sorter: {
        compare: (a, b) => a.month_salary - b.month_salary,
      },
      render: (text, record) => {
        return <div>$ {text}</div>;
      },
    },
    {
      title: "Created Date",
      dataIndex: "add_timestamp",
      align: "center",
      sorter: {
        compare: (a, b) => a.add_timestamp.localeCompare(b.add_timestamp),
      },
    },
    {
      title: "Updated Date",
      dataIndex: "update_timestamp",
      align: "center",
      sorter: {
        compare: (a, b) => a.update_timestamp.localeCompare(b.update_timestamp),
      },
    },
  ];
  const dataSource = dataList.map((info) => {
    return { ...info, key: info.id };
  });

  return (
    <div className="list-table">
      <Table
        size="small"
        pagination={
         false
        }
        columns={columns}
        dataSource={dataSource}
      />
    </div>
  );
};

export default withRouter(DetailTable);
